import React from "react";
import { Box, Grid } from "@mui/material";
import {
  AccountBoxOutlined,
  EmailOutlined,
  Phone,
  PeopleOutlined,
} from "@mui/icons-material";

import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import InformationTile from "components/Shared/InformationTile";
import { useVendorStaffDetailContext } from "contexts/VendorStaffDetailContext";

const VendorStaffBasicDetail = () => {
  const { vendorStaffDetail, loadingVendorStaffDetail } = useVendorStaffDetailContext();

  return !loadingVendorStaffDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountBoxOutlined color="primary" />}
                  title="Name"
                >
                  {vendorStaffDetail?.name || "N/A"}
                </InformationTile>
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountBoxOutlined color="primary" />}
                  title="Staff ID"
                >
                  {vendorStaffDetail?.vendorStaffId	 || "N/A"}
                </InformationTile>
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <EmailOutlined color="primary" />}
                  title="Email"
                >
                  {vendorStaffDetail?.email || "N/A"}
                </InformationTile>
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <Phone color="primary" />}
                  title="Phone"
                >
                  {vendorStaffDetail?.phone || "N/A"}
                </InformationTile>
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <PeopleOutlined color="primary" />}
                  title="Connected Vendor"
                >
                  {vendorStaffDetail?.connectedVendor?.name || "N/A"}
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default VendorStaffBasicDetail;